import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemRolesActorsGroupsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-roles-actors-groups',
	path: '/secure/project/GroupRoleActorAction.jspa',
};
